import { Route, BrowserRouter as Router, Routes } from 'react-router-dom';

import Footer from 'core/components/Footer/index';
import NavBar from 'core/components/NavBar';
import ScrollToTop from 'core/components/ScrollToTop';
import './core/context/Translation';
import Home from 'features/home';
import Ironing from 'features/ironing/components';
import Sewing from './features/sewing/components';
import DryCleaning from 'features/dryCleaning/components';

function App() {
  return (
    <Router>
      <ScrollToTop />
      <NavBar />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/sewing" element={<Sewing />} />
        <Route path="/ironing" element={<Ironing />} />
        <Route path="/dryCleaning" element={<DryCleaning />} />
      </Routes>
      <Footer />
    </Router>
  );
}

export default App;
